import { render, staticRenderFns } from "./HomeLayout.vue?vue&type=template&id=79b91584&scoped=true"
import script from "./HomeLayout.vue?vue&type=script&lang=ts"
export * from "./HomeLayout.vue?vue&type=script&lang=ts"
import style0 from "./HomeLayout.vue?vue&type=style&index=0&id=79b91584&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b91584",
  null
  
)

export default component.exports